import { useEffect, useMemo } from "react"
import { useThree } from "@react-three/fiber"
import { PMREMGenerator, LoadingManager, UnsignedByteType } from "three"
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js"
// import { test } from "../../../../public/assets/apartmentfinder/lighting/"
const hdriPath = `${process.env.PUBLIC_URL}/assets/apartmentFinder/lighting/`
// const hdriPath = `../../../../public/assets/apartmentFinder/lighting/`

const Enviro = ({ callActive, hdriFile }) => {
  const manager = useMemo(() => {
    return new LoadingManager()
  }, [])
  const { gl, scene } = useThree()

  const pmremGenerator = useMemo(() => {
    return new PMREMGenerator(gl)
  }, [gl])

  const loader = useMemo(() => {
    return new RGBELoader(manager)
      .setPath(hdriPath)
      .setDataType(UnsignedByteType)
  }, [manager])

  pmremGenerator.compileEquirectangularShader()

  // useEffect(() => {
  //   loader.load(`${hdriPath}/${hdriFile}.hdr`, texture => {
  //     // callActive();
  //     const envMap = pmremGenerator.fromEquirectangular(texture).texture
  //     scene.environment = envMap
  //     texture.dispose()
  //     pmremGenerator.dispose()
  //   })
  // }, [callActive, scene, loader, pmremGenerator])

  useEffect(() => {
    // loader.load(
    //   "https://web-app-demos.s3.eu-west-2.amazonaws.com/assets/sky.hdr",
    //   texture => {
    //     // callActive();
    //     const envMap = pmremGenerator.fromEquirectangular(texture).texture
    //     scene.background = envMap
    //     // console.log(texture)
    //     texture.dispose()
    //     pmremGenerator.dispose()
    //   }
    // )
  }, [callActive, scene, loader, pmremGenerator])

  return null
}

export default Enviro
